import styled from 'styled-components';

export const SpinnerPlaceholder = styled.div`
  width: 100%;
  height: 50vh;
`;
